export const blockIconsUiactionsCheckNew = (
	<span className='material-symbols-outlined'>check</span>
);
